/**
 * @see https://github.com/Modernizr/Modernizr/blob/master/feature-detects/img/webp.js
 */
const checkWebpSupport = () =>
  new Promise<boolean>((res) => {
    const img = new Image();

    img.src =
      'data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==';
    img.onload = () => res(true);
    img.onerror = () => res(false);
  });

export default checkWebpSupport;
